
























































import { computed, defineComponent, toRefs, getCurrentInstance } from '@vue/composition-api';
import { UserIcon, EllipsisIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  components: {
    UserIcon,
    EllipsisIcon,
  },
  props: {
    historyItem: {
      required: true,
      type: Object,
    },
    historyKey: {
      required: true,
      type: Number,
    },
    len: {
      required: true,
      type: Number,
    },
    curHistoryId: {
      require: true,
      type: String,
    },
  },
  setup(props) {
    const map: Record<number, string> = {
      0: i18n_t('创建'),
      1: i18n_t('更新'),
      2: i18n_t('恢复'),
    };
    const methods = {
      getOpreatePrivelegeSubMenu(item: any) {
        const options = [
          {
            content: i18n_t('在线预览'),
            value: 'preview',
            able: item.authorityList?.canPreview,
          },
          {
            content: i18n_t('下载'),
            value: 'download',
            able: item.authorityList?.canDownload,
          },
          {
            content: i18n_t('设为最新'),
            value: 'setLatest',
            able: !item.isLatestVersion && item.authorityList?.canModify,
          },
          {
            content: i18n_t('删除'),
            value: 'delete',
            able: !item.isLatestVersion && item.authorityList?.canDelete,
          },
        ];

        return options.filter(i => i.able);
      },
    };
    const opreatePrivelegeSubMenu = computed(() => {
      return methods.getOpreatePrivelegeSubMenu(props.historyItem);
    });
    return {
      ...methods,
      map,
      opreatePrivelegeSubMenu,
    };
  },
});
